var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_57_1947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5033 15.1265L31.5022 15.1253L25.1337 8.78753C24.6566 8.31274 23.8849 8.31451 23.41 8.79167C22.9351 9.26877 22.937 10.0405 23.4141 10.5153L27.6899 14.7704H1.87822C1.20508 14.7704 0.659424 15.316 0.659424 15.9892C0.659424 16.6623 1.20508 17.208 1.87822 17.208H27.6898L23.4141 21.4631C22.937 21.9379 22.9352 22.7096 23.41 23.1867C23.885 23.6639 24.6567 23.6656 25.1337 23.1908L31.5022 16.8531L31.5033 16.8519C31.9807 16.3755 31.9791 15.6013 31.5033 15.1265Z",
    fill: "#DC6200"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2013,
    height: 31.2013,
    fill: "white",
    transform: "translate(0.659424 0.388672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.267417cd7c213197dc14c1e8a3352474.svg";
export { ForwardRef as ReactComponent };